
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { DOCUMENT } from "@angular/common";
import { Injectable, Inject } from '@angular/core';
import { ErrorHandlerService } from './error-handler.service';
import { LoggerService } from './logger.service';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { AcessoExterno } from './../models/acesso-externo.model';
import { Acesso } from './../models/acesso.model';
import { blockUi } from '@smdapp/ng-shared/components/loading-overlay/loading-interceptor';
import { Router } from "@angular/router";
import { SessionStorageService } from "./session-storage.service";

const URL_REALIZAR_ACESSO_TOKEN: string = 'rest/api/externo/realizarAcessoExterno';
const URL_REALIZAR_ACESSO_EXTERNO_TOKEN: string = 'rest/api/externo/auth';
const URL_REALIZAR_LOGOUT_ACESSO_EXTERNO_TOKEN: string = 'rest/api/externo/auth/revoke';
const URL_REALIZAR_ACESSO_EXTERNO_GOVBR: string = 'rest/api/externo/authgovbr';
const URL_GET_PRC_GOVBR: string = 'rest/api/externo/prcgovbr';
const URL_GET_GOVBR: string = 'rest/api/externo/urlgovbr';


@Injectable()
export class AcessoExternoService
{
    private readonly urlBase = location.origin + '/smd_spa/';

    constructor(
        @Inject(DOCUMENT) protected document: Document,
        private router: Router,
        private logger: LoggerService,
        private sessionStorageService: SessionStorageService,
        private errorHandlerService: ErrorHandlerService,
        private httpClient: HttpClient)
    {
    }



    public realizarAcessoExterno = (acessoExternoEmailDTO : Acesso) : Promise<Acesso> =>
    {
        acessoExternoEmailDTO.dataGeracaoAcesso = new Date();

        return new Promise((resolve, reject) =>
        {

            let options = {
                headers: new HttpHeaders({'Content-Type': 'application/json'})
              };

            let url = this.urlBase + URL_REALIZAR_ACESSO_TOKEN
            let servicoAcessoExterno =
             this.httpClient.post(url, acessoExternoEmailDTO, options).pipe(
                  map(response => this.convertToTypeAcesso(response)),
                  catchError((e) => this.handleError(e)),);

                servicoAcessoExterno.subscribe(
                (acesso: Acesso) =>
                {
                    return resolve(acesso);
                },
                (err: any) =>
                {
                    this.logger.error('[AcessoExternoService / realizarAcessoExterno] Erro ao realizar acesso externo ', err);
                    return reject(err);
                }
            );
        });
    }

    public realizarAcessosExterno = (acessoExternoEmailDTO : AcessoExterno) : Promise<AcessoExterno> =>
    {
        acessoExternoEmailDTO.dataGeracaoAcesso = new Date();

        this.realizarLogoutGovBr(null);

        return new Promise((resolve, reject) =>
        {
            let url = this.urlBase + URL_REALIZAR_ACESSO_EXTERNO_TOKEN
            let servicoAcessoExterno =
             this.httpClient.post(url, acessoExternoEmailDTO, blockUi({
                headers: new HttpHeaders({'Content-Type': 'application/json'}),
                observe: 'response'
             })).pipe(map((response:HttpResponse<any>) => {
                        return this.convertToType(response.body);
                   }),catchError((e) => this.handleError(e)),);

                servicoAcessoExterno.subscribe(
                (acessoExterno: AcessoExterno) =>
                {
                    return resolve(acessoExterno);
                },
                (err: any) =>
                {
                    this.logger.error('[AcessoExternoService / realizarAcessoExterno] Erro ao realizar acesso externo ', err);
                    return reject(err);
                }
            );
        });
    }

    public realizarAcessosExternoGovBr = (acessoExternoEmailDTO : AcessoExterno) : Promise<AcessoExterno> =>
    {
        acessoExternoEmailDTO.dataGeracaoAcesso = new Date();

        return new Promise((resolve, reject) =>
        {
            let url = this.urlBase + URL_REALIZAR_ACESSO_EXTERNO_GOVBR
            let servicoAcessoExterno =
             this.httpClient.post(url, acessoExternoEmailDTO, blockUi({
                headers: new HttpHeaders({'Content-Type': 'application/json'}),
                observe: 'response'
             })).pipe(map((response:HttpResponse<any>) => {
                        return this.convertToType(response.body);
                   }),catchError((e) => this.handleError(e)),);

                servicoAcessoExterno.subscribe(
                (acessoExterno: AcessoExterno) =>
                {
                    return resolve(acessoExterno);
                },
                (err: any) =>
                {
                    this.logger.error('[AcessoExternoService / realizarAcessosExternoGovBr] Erro ao realizar acesso externo com GOV.BR', err);
                    return reject(err);
                }
            );
        });
    }

    public redirecionaAcessoGovBr()
    {
        this.logger.debug('[redirecionaAcessoGovBr] Obtendo url PRC Gov Br');

        return new Promise((resolve, reject) => {
            let getUrlPrcGovBr = this.httpClient.get(this.urlBase+URL_GET_PRC_GOVBR, blockUi()).pipe(
            catchError((e) => this.handleError(e)));

            getUrlPrcGovBr.subscribe(
                (acessoExternoEmailDTO) => {
                    return resolve(acessoExternoEmailDTO);
                },
                (error: any) => {
                    this.logger.error('[redirecionaAcessoGovBr] Erro ao buscar url PRC GOV BR', error);
                    return reject(error);
                });
        });
    }

    public realizarLogoutGovBr(navegarPara)
    {
          let that = this;
          this.sessionStorageService.limparDadosSessaoParaGovBr();

          let getUrlGovBr = this.httpClient.get(this.urlBase+URL_GET_GOVBR, blockUi()).pipe(
          catchError((e) => this.handleError(e)));

          getUrlGovBr.subscribe((acessoExternoEmailDTO: AcessoExterno) =>
          {
            let logoutUrl = `${acessoExternoEmailDTO.urlGovBr}/logout?post_logout_redirect_uri=${encodeURI(window.location.href)}`;
            var janelaParaLogoutGovBr = window.open(logoutUrl,"_blank","location=yes,height=10,width=10,scrollbars=no,status=no");
            setTimeout(() => {
              if (janelaParaLogoutGovBr != null)
              {
                janelaParaLogoutGovBr.close();
              }
              if (navegarPara != null)
              {
                that.router.navigate([navegarPara]);
              }
            }, 1000);
          },(error: any) => {
            this.logger.error('[redirecionaAcessoGovBr] Erro ao buscar url PRC GOV BR', error);
          });
    }

    public realizarLogoutAcessoExterno()
    {
        let options = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
        };
        let url = this.urlBase + URL_REALIZAR_LOGOUT_ACESSO_EXTERNO_TOKEN

        return this.httpClient.post(url, options)
        .toPromise()
    }


    public handleError(responseError: HttpErrorResponse | any)
    {
        this.logger.error('Erro ao realizar requisição no servidor', responseError);
        return observableThrowError(this.errorHandlerService.createErrorApp(responseError));
    }

    protected convertToType(value): AcessoExterno {
        return <AcessoExterno>Object.assign(new AcessoExterno(), value);
    }

    protected convertToTypeAcesso(value): Acesso {
        return <Acesso>Object.assign(new Acesso(), value);
    }

}

